import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ChartConfigService {

  constructor() { }


  private mapSeriesById(series: any[], idKey: string): Record<string, any> {
    return series.reduce((map: Record<string, any>, serie: any) => {
      const id = serie.options?.[idKey] || serie[idKey];
      if (id) {
        map[id] = serie;
      }
      return map;
    }, {});
  }


  private needsUpdate(existingSerie: any, newSerieConfig: any): boolean {
    return (
      existingSerie.data.length !== newSerieConfig.data.length ||
      !existingSerie.data.every(
        (point: any, i: number) => point.y === newSerieConfig.data[i]?.y
      )
    );
  }

  public updateChartSeries(filters: any, chart: any, currentSeries: any, newSeries: any): void {
    const currentSeriesMap = this.mapSeriesById(currentSeries, 'id');
    const newSeriesMap = this.mapSeriesById(newSeries, 'id');

    filters.flatMap((filterCategory) => filterCategory.filters).forEach((filter: any) => {
      const key = filter.useValueAsKey ? filter.value : filter.key;
      const existingSerie = currentSeriesMap[key];
      const newSerieConfig = newSeriesMap[key];

      if (existingSerie && !newSerieConfig) {
        existingSerie.remove(false);
      } else if (!existingSerie && newSerieConfig) {
        chart.addSeries(newSerieConfig, false);
      } else if (existingSerie && newSerieConfig && this.needsUpdate(existingSerie, newSerieConfig)) {
        existingSerie.setData(newSerieConfig.data, false);
      }
    });
    chart.redraw();
    chart.reflow();
  }



}
